import { MerchantTerminalDto } from "@admin_api/models/merchant-terminal-dto";

export class DeviceState {
    loading = false;
    record: MerchantTerminalDto = {};
    error = null;
}
